export default __webpack_public_path__ + "static/media/nova-su.6ad17069.webp";